module.exports = __webpack_public_path__ + "static/media/zym-logo@3x.e917c1dd.png";